import moment from "moment";
import MPMContext from "mpm-config/context/MPMContext";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Header, Icon, Modal } from "semantic-ui-react";

const DisconnectModal = () => {
  const context = React.useContext(MPMContext);
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <Modal
      open={open}
      trigger={
        <button className="mobile-menu-button p-4 focus:outline-none focus:bg-gray-700" onClick={() => setOpen(true)}>
        {
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWdth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        }
        
      </button>
      }
      basic
      size="small"
      onClose={() => setOpen(false)}
    >
      <Header
        icon="power off"
        content={<FormattedMessage id="label.logout-header" />}
      />
      <Modal.Content>
        <p>
          <FormattedMessage id="label.logout-description" />
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button basic color="red" inverted onClick={close}>
          <Icon name="remove" /> <FormattedMessage id="label.no" />
        </Button>
        <Button color="green" inverted onClick={context.logout}>
          <Icon name="checkmark" /> <FormattedMessage id="label.yes" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

class TopMenuMobile extends React.Component {
  
  render() {
    return (
      <div className="bg-gray-800 text-gray-100 fixed w-screen z-50 top-0 flex justify-between ">
        <div className="flex flex-col p-2 flex-grow justify-center">
            <p className="text-xs text-white m-0 text-gray-100 ">Bienvenue,</p>
            <p className="text-xs text-white font-bold text-blue-200">
              {this.context.connectedUser.nom}{" "}
              {this.context.connectedUser.prenom}
            </p>
        </div>
        <div className="hidden md:flex flex-col p-2  justify-center">
            <p className="text-xs text-white m-0 text-gray-100 "><FormattedMessage id="label.lastconnexion" tagName="label" /></p>
            <p className="text-xs text-white font-bold text-blue-200">
              {moment(this.context.connectedUser.lastConnexion).format("DD/MM/YYYY HH:mm:ss")}
            </p>
        </div>
        <button className="mobile-menu-button p-4 focus:outline-none focus:bg-gray-700" onClick={this.props.handleMenuClick}>
          {
            !this.props.bigMenu ? <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg> : <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          }
          
        </button>
        <DisconnectModal />
      </div>
      
    );
  }
}
TopMenuMobile.contextType = MPMContext;
export default TopMenuMobile;
